module.exports = __webpack_public_path__ + "static/media/icon_location_current.e87203c8.svg";